import { useState } from 'react';
import apiClient from '../utils/api';

interface UserStatsEntry {
  sex: string;
  height: number;
  activity: string;
  goalWeight: number;
}

export const useUserStats = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const saveUserStats = async (entry: UserStatsEntry): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      await apiClient.post('/user-stats', entry);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to save user stats. Please try again.';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    saveUserStats,
    loading,
    error,
  };
};
